<template>
	<div v-if="asset != null">
		<h1 class="mb-3">
			{{asset.asset_type}} {{asset.number}} <small class="text-muted"> Proyecto {{asset.project_name}}</small>
		</h1>
		<options :asset_id="asset.asset_id" :tab_index="tab_index" :project_id="asset.project_id" />
	</div>
</template>
<script>
	import options from "./Options";
	export default {
		name: "apartments",
		components: {options},
		props: {
			asset: {default: null},
			tab_index: {default: null}
		},
		data() {
			return {
				selectedApartment: null,
				apartments: [],
        //domain: process.env.VUE_APP_CUSTOMER_DOMAIN
			}
		},
		mounted() {
		}
	};
</script>
<style>
	.list-Apartment {
		height: 16em;
	}
</style>